"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialButton = exports.isMaterialButton = void 0;
const router_1 = require("client/components/router");
const Button_1 = require("material-ui/Button");
const react_1 = require("react");
const React = require("react");
exports.isMaterialButton = (value) => value && value.type && value.type === MaterialButton;
class MaterialButton extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onClick = (e) => {
            const { onClick, to } = this.props;
            if (to) {
                router_1.RouteManager.transitionTo(to);
            }
            onClick && onClick(e);
        };
        this.onMouseEnter = (e) => {
            this.props.onMouseEnter && this.props.onMouseEnter(e);
        };
    }
    render() {
        const { children, className, disabled, fab, flat, href, primary, secondary, title } = this.props;
        const primaryColor = primary ? "primary" : null;
        const secondaryColor = secondary ? "secondary" : null;
        const color = primaryColor || secondaryColor || "default";
        const flatStyle = flat ? "flat" : null;
        const fabStyle = fab ? "fab" : null;
        const variant = flatStyle || fabStyle || "raised";
        const button = (React.createElement(Button_1.default, { variant: variant, color: color, disabled: disabled, type: this.props.type || "button", className: `material-button ${className}`, href: href, title: title, onClick: this.onClick, onMouseEnter: this.onMouseEnter, style: this.props.style }, children));
        // A disabled button gets pointer-events: none, so the browser never fires
        // the hover that shows its title. The wrapper keeps the tooltip reachable.
        return disabled && title ? (React.createElement("span", { title: title, style: { display: "inline-block" } }, button)) : (button);
    }
}
exports.MaterialButton = MaterialButton;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/button/button.tsx
// module id = 2125
// module chunks = 0 1 2